import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommandBase, FilteredCommand, MultiselectCommand, standardCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { IncorrectPaymentService } from '../data/incorrect-payment.service';

@Injectable()
export class IncorrectPaymentExportCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: IncorrectPaymentService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command.id !== standardCommand.export) {
      return false;
    }
    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    if (command instanceof MultiselectCommand) {
      return command.itemsSource.length > 0;
    }
  }

  execute(command: CommandBase): Observable<void> {
    if (command instanceof FilteredCommand) {
      return this._dataService
        .exportFiltered(
          command.filterProvider.filterState,
          command.includedIds,
          command.excludedIds,
          command.totalAffectedItemsControlValue
        )
        .pipe(map(file => this._nativeWindow.save(file)));
    }
    if (command instanceof MultiselectCommand) {
      return this._dataService
        .exportFiltered(
          {},
          command.items.map(item => item.id),
          [],
          command.items.length
        )
        .pipe(map(file => this._nativeWindow.save(file)));
    }
  }
}
